import Typography from "@mui/material/Typography";
import {Avatar, Grid} from "@mui/material";
import Box from "@mui/material/Box";

export default function Sponsors() {
    const sponsorSize = 2.4;
    return (
        <Box sx={{mt: 1}}>
            <Typography gutterBottom variant="h6" textAlign={'center'}>
                Sponsors
            </Typography>

            <Grid container sx={{pr: 3, pl: {xs: 3, sm: 0}}} spacing={3}>
                <Grid item xs={6} sm={sponsorSize}>
                    <Typography gutterBottom variant="body2" textAlign={'center'}>
                        Historic Brass Society
                    </Typography>
                    <img width='100%' height='auto' alt="Historic Brass Society" src="/Images/Sponsors/HBSLogo.gif"/>
                </Grid>
                <Grid item xs={6} sm={sponsorSize}>
                    <Typography sx={{pb: 1}} gutterBottom variant="body2" textAlign={'center'}>
                        BfB Brass™
                    </Typography>
                    <img width='100%' height='auto' alt="BfB Brass" src="/Images/Sponsors/BFB-Brass-left-grey.png"/>
                </Grid>
                <Grid item xs={6} sm={sponsorSize}>
                    <Typography gutterBottom variant="body2" textAlign={'center'}>
                        Maller Brass Instruments
                    </Typography>
                    <img width='100%' height='auto' alt="Maller Brass Instruments"
                         src="/Images/Sponsors/MALLER BRASS LOGO.png"/>
                </Grid>
                <Grid
                    sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'column'}}
                    item xs={6} sm={sponsorSize}>
                    <Typography gutterBottom variant="body2" textAlign={'center'}>
                        ITG
                    </Typography>
                    <Avatar sx={{width: '70%', height: 'auto'}} alt="CSU ITG" src="/Images/Sponsors/ITGLogo.png"/>
                </Grid>
                <Grid
                    sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'column'}}
                    item xs={6} sm={sponsorSize}>
                    <Typography gutterBottom variant="body2" textAlign={'center'}>
                        Bach Gesellschaft
                    </Typography>
                    <img width='120%' height='auto' alt="" src="/Images/Sponsors/NBG_Logo_eV_CMYK.jpg"/>
                </Grid>

                <Grid item xs={6} sm={sponsorSize}>
                    <Typography gutterBottom variant="body2" textAlign={'center'}>
                        Egger
                    </Typography>
                    <img width='100%' height='auto' alt="Egger" src="/Images/Sponsors/Egger.jpg"/>
                </Grid>
                <Grid item xs={6} sm={sponsorSize}>
                    <Typography sx={{pb: 1}} gutterBottom variant="body2" textAlign={'center'}>
                        Martin Schmid
                    </Typography>
                    <img width='100%' height='auto' alt="" src="/Images/Sponsors/Martin Schmid.jpg"/>
                </Grid>
                <Grid item xs={6} sm={sponsorSize}>
                    <Typography gutterBottom variant="body2" textAlign={'center'}>
                        Bad Säckingen Trumpet Museum
                    </Typography>
                    <img width='100%' height='auto' alt="" src="/Images/Sponsors/Museum.jpg"/>
                </Grid>
                <Grid
                    sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'column'}}
                    item xs={6} sm={sponsorSize}>
                    <Typography gutterBottom variant="body2" textAlign={'center'}>
                        Neubauer
                    </Typography>
                    <img width='70%' height='auto' alt="" src="/Images/Sponsors/Neubauer2.jpg"/>
                </Grid>
                <Grid
                    sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'column'}}
                    item xs={6} sm={sponsorSize}>
                    <Typography gutterBottom variant="body2" textAlign={'center'}>
                        Bach Stiftung
                    </Typography>
                    <img width='120%' height='auto' alt="" src="/Images/Sponsors/NBG_Logo_Stiftung_CMYK.jpg"/>
                </Grid>
                <Grid
                    sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'column'}}
                    item xs={6} sm={sponsorSize}>
                    <Typography gutterBottom variant="body2" textAlign={'center'}>
                        Sparkasse Hochrhein
                    </Typography>
                    <img width='100%' height='auto' alt="" src="/Images/Sponsors/Logo_Sparkasse_Hochrhein_Druck.jpg"/>
                </Grid>
                <Grid
                    sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'column'}}
                    item xs={6} sm={sponsorSize}>
                    <Typography gutterBottom variant="body2" textAlign={'center'}>
                        City of Bad Säckingen
                    </Typography>
                    <img width='100%' height='auto' alt="" src="/Images/Sponsors/BS-Logo-hco.png"/>
                </Grid>
                <Grid
                    sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'column'}}
                    item xs={12} sm={7.2}>
                    <Typography gutterBottom variant="body2" textAlign={'center'}>
                        Sparkassen-Kulturstiftung
                    </Typography>
                    <img width='100%' height='auto' alt="" src="/Images/Sponsors/Logo_Sparkasse-Kulturstiftung_Bad_Saeckingen.jpg"/>
                </Grid>
            </Grid>
        </Box>
    )
}